<template>
  <div class="submission">
    <div>
      <!-- <logo /> -->
      <h1 class="title">artful at heart</h1>
      <h2 class="subtitle">submission {{$route.params.id}}</h2>
    </div>
    <div class="head">
      <a href>bback</a>
      <a href="./">cross</a>
    </div>
    <div class="body"><img :src="'https://app.brighton.com/brighton-your-day/tmp/'+"</div>
  </div>
</template>

<script>
const axios = require("axios");
export default {
  props: {},
  data() {
    return {
      submissions: null
      // showModal: false,
      // submissionToShow: null
    };
  },
  components: {
    // Logo
    // submissionPopup
  },
  mounted() {
    console.log("mounted");
    this.getSubmission();
  },
  methods: {
    getSubmission() {}
  }
};
</script>

<style lang="scss" scoped>
html {
  background: #ebebeb;
}
.submission {
  /* max-width:90%; */
  margin: 0 auto;
  height: 100%;
  display: block;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: #ebebeb;

  .item {
    padding: 10px;
    text-align: left;
    box-sizing: border-box;
    position: relative;

    .mask {
      cursor: pointer;
      top: 0;
      left: 0;
      width: 100%;
      height: 90%;
      z-index: 0;
      padding-bottom: 0px;
      opacity: 0;
      position: absolute;
      background: rgba(0, 0, 0, 0.2);
      border-radius: 5px;
      -webkit-transition: all 0.3s;
      transition: all 0.3s;
    }
    .post {
      width: 214px;
      position: relative;

      .text {
        max-width: 100%;
        display: block;
        padding: 5px;
        margin: 0;
        span {
          display: block;
          font-size: 13px;
        }
        span.text1 {
          line-height: 1.5;
          font-weight: bold;
        }
        span.textCollpased {
          cursor: pointer;
          span {
            display: inline-block;
            font-size: 11px;
            text-decoration: underline;
          }
        }
      }

      img {
        border-radius: 5px;
        max-width: 100%;
        background: rgba(255, 192, 203, 0.6);
        cursor: zoom-in;
        /* padding: 10px; */
        /* box-sizing: border-box; */
      }
    }
  }

  .submissions {
    .submission {
      img {
        display: block;
        max-width: 100%;
      }
    }
  }
}

/* .homeContainer .item .post:hover .mask, */
.homeContainer .item:hover .mask {
  opacity: 0.3;
  /* padding-bottom:25px; */
  height: 100%;
}

/* 

.grid-item { width: 200px; }
.grid-item--width2 { width: 400px; }
 */
</style>
